module.exports = __webpack_public_path__ + "static/media/portfolio-3.7fb40304.jpg";